module.exports = __webpack_public_path__ + "media/images/athletes/2596-3005c5b21a2d262e76af60d04c0f6092.png";